import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=c5cf2004&scoped=true&"
import script from "./Main.vue?vue&type=script&lang=js&"
export * from "./Main.vue?vue&type=script&lang=js&"
import style0 from "./Main.vue?vue&type=style&index=0&id=c5cf2004&prod&lang=css&"
import style1 from "./Main.vue?vue&type=style&index=1&id=c5cf2004&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5cf2004",
  null
  
)

export default component.exports